<template>
  <div>
    <Menu mode="horizontal" :active-name="$route.name" @on-select="selectMenu">
      <span style="float: left">
        <a style="margin-left: 24px; margin-right: 24px;" v-on:click="$router.push({ name: 'server' })">
        <Icon type="md-arrow-round-back" size="18" />
      </a>
      </span>
      <MenuItem name="private_cloud_server_detail">
        基本信息
      </MenuItem>
      <!--<MenuItem name="2">-->
        <!--监控-->
      <!--</MenuItem>-->
      <MenuItem name="private_cloud_server_console">
        控制台
      </MenuItem>
      <MenuItem name="private_cloud_server_console_log">
        控制台日志
      </MenuItem>
      <MenuItem name="private_cloud_server_operate_log">
        操作日志
      </MenuItem>
      <div style="text-align: right">
        <div style="margin-right: 10px">
          <Button @click="init()" style="margin-right: 10px" size="small" icon="md-refresh">刷新</Button>
          <ActionMenu
            ref="ActionMenu"
            :status="info.status"
            :server_id="info.id"
            :server_name="info.name" v-on:callback="init()"></ActionMenu>
        </div>
      </div>
    </Menu>
    <div class="private-cloud-resource-detail-content">
      <div class="main">
        <div>
          <Row :gutter="4">
            <Spin fix v-if="infoLoading"></Spin>
            <Col :lg="8">
              <Alert show-icon v-if="infoError" type="error">
                <span>获取实例数据失败</span>
                <a style="float: right" v-on:click="getDetail">重新获取</a>
              </Alert>
              <div v-else>
                <div class="info-property">
                  <div class="resource-content-title">
                    <h4>实例信息</h4>
                  </div>
                  <dl>
                    <dt>实例名称</dt><dd>{{ info.name }}</dd>
                  </dl>
                  <dl>
                    <dt>实例 ID</dt><dd>{{ info.id }}</dd>
                  </dl>
                  <dl>
                    <dt>实例状态</dt>
                    <dd v-if="info.status"><Badge :text="statusTransfer(info.status).status" :status="statusTransfer(info.status).color"></Badge></dd>
                  </dl>
                  <!--<dl>-->
                  <!--<dt>锁定</dt>-->
                  <!--<dd v-if="info.detail_info">{{ info.detail_info.locked }}</dd>-->
                  <!--</dl>-->
                  <dl>
                    <dt>区域</dt>
                    <dd>{{ info['OS-EXT-AZ:availability_zone'] }}</dd>
                  </dl>
                  <dl>
                    <dt>租户</dt>
                    <dd>{{ resourceProjectIdTransName(info.tenant_id) }}</dd>
                  </dl>
                  <dl>
                    <dt>创建时间</dt><dd v-if="info.created">{{ moment(info.created).format('YYYY-MM-DD HH:mm:ss') }}</dd>
                  </dl>
                  <dl>
                    <dt>更新时间</dt><dd v-if="info.updated">{{ moment(info.updated).format('YYYY-MM-DD HH:mm:ss') }}</dd>
                  </dl>
                </div>
                <div class="info-property" v-if="flavorInfo">
                  <div class="resource-content-title">
                    <h4>实例规格</h4>
                  </div>
                  <dl v-if="flavorInfo">
                    <dt>名称</dt>
                    <dd>{{flavorInfo.name}}</dd>
                  </dl>
                  <dl v-if="flavorInfo">
                    <dt>内存</dt>
                    <dd>{{flavorInfo.ram}} MB</dd>
                  </dl>
                  <dl v-if="flavorInfo">
                    <dt>VCPU数量</dt>
                    <dd>{{flavorInfo.vcpus}}</dd>
                  </dl>
                  <dl v-if="flavorInfo">
                    <dt>磁盘</dt>
                    <dd>{{flavorInfo.disk}} GB</dd>
                  </dl>
                </div>
                <div class="info-property">
                  <div class="resource-content-title">
                    <h4>镜像信息</h4>
                  </div>
                  <dl v-if="imageInfo">
                    <dt>镜像名称</dt>
                    <dd>
                      <a v-on:click="$router.push({name: 'image_detail', params: {'id': imageInfo.id}})">{{ imageInfo.name }}</a>
                    </dd>
                  </dl>
                  <dl v-if="imageInfo">
                    <dt>镜像 ID</dt>
                    <dd>{{ imageInfo.id }}</dd>
                  </dl>
                </div>
                <div class="info-property">
                  <div class="resource-content-title">
                    <h4>网络信息</h4>
                  </div>
                  <dl v-for="(value, key, index) in info.addresses" :key="'addresses_index_' + index">
                    <dt>{{ key }}</dt>
                    <dd>
                      <div v-for="(item, itemIndex) in value" :key="'itemIndex_' + itemIndex + '_' + itemIndex">
                        <span>{{ item['OS-EXT-IPS:type'] === 'floating' ? '浮动IP' : '固定IP' }}：{{ item.addr }}</span>
                      </div>
                    </dd>
                  </dl>
                </div>
              </div>
            </Col>
            <Col :lg="16">
              <div class="resource-content">
                <div class="resource-content-title">
                  <h4>高级信息</h4>
                </div>
                <div class="resource-tree">
                  <icon type="iconfont icon-SecurityGroupmem-W" class="icon-iconfont" style="color: #ff9900" size="30"></icon>
                  <span style="margin-left: 15px">安全组</span>
                  <Row v-if="securityGroupsGetting">
                    <Spin fix></Spin>
                  </Row>
                  <div v-for="item in securityGroups" :key="item.id" class="resource-tree-content">
                    <i class="resource-tree-left-line"></i>
                    <div class="resource-tree-content-data">
                      <div class="resource-tree-data-body">
                        <i class="resource-tree-line-icon"></i>
                        <ServerSecurityGroupInfo :info="item"></ServerSecurityGroupInfo>
                      </div>
                    </div>
                  </div>
                  <div class="resource-tree-content">
                    <div class="resource-tree-content-data">
                      <i class="resource-tree-left-line resource-tree-left-line-last"></i>
                      <div class="resource-tree-data-body" style="background: unset">
                        <i class="resource-tree-line-icon"></i>
                        <a v-on:click="$refs.ActionMenu.actionTrigger('setSecurityGroup')">配置</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="resource-tree">
                  <icon type="iconfont icon-storage" class="icon-iconfont" style="color: #66CCCC" size="30"></icon>
                  <span style="margin-left: 15px">云硬盘</span>
                  <div v-for="item in info['os-extended-volumes:volumes_attached']" :key="item.id" class="resource-tree-content">
                    <div class="resource-tree-content-data">
                      <i class="resource-tree-left-line"></i>
                      <div class="resource-tree-data-body" >
                        <i class="resource-tree-line-icon"></i>
                        <ServerVolumeInfo :volume-id="item.id"></ServerVolumeInfo>
                      </div>
                    </div>
                  </div>
                  <div class="resource-tree-content">
                    <div class="resource-tree-content-data">
                      <i class="resource-tree-left-line resource-tree-left-line-last"></i>
                      <div class="resource-tree-data-body" style="background: unset">
                        <i class="resource-tree-line-icon"></i>
                        <a v-on:click="$refs.ActionMenu.actionTrigger('attachVolume')">挂载</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { detailPrivateCloudServer, getPrivateCloudServerSecurityGroups } from '@/api/private-cloud/server'
import { detailPrivateCloudFlavor } from '@/api/private-cloud/flavor'
import { detailPrivateCloudImage } from '@/api/private-cloud/image'
import { resourceIdTransName } from '@/view/private-cloud/cacheData'
import { statusTransfer } from './components/server_status_transfer'
import ActionMenu from './components/ActionMenu'
import ServerVolumeInfo from './components/server-volume-info'
import ServerSecurityGroupInfo from './components/server-security-group-info'
import moment from 'moment'

export default {
  name: 'image-detail',
  components: {
    ActionMenu,
    ServerVolumeInfo,
    ServerSecurityGroupInfo
  },
  data () {
    return {
      info: {},
      infoLoading: false,
      infoError: false,
      logLoading: false,
      logError: false,
      moment: moment,
      flavorInfo: null,
      imageInfo: null,
      securityGroupsGetting: false,
      securityGroups: []
    }
  },
  mounted: function () {
    this.init()
  },
  watch: {
    '$route' (to, from) {
      if (this.$route.params.id) {
        this.init()
      }
    }
  },
  methods: {
    // 初始化
    init () {
      this.info = {}
      this.securityGroups = []
      this.getDetail()
    },
    // 获取实例详细信息
    getDetail () {
      this.infoLoading = true
      detailPrivateCloudServer(this.$route.params.id).then(res => {
        this.infoError = false
        this.info = res.data.server
        this.getFlavorInfo()
        this.getImageInfo()
        this.getBindSecurityGroup()
        this.infoLoading = false
      }).catch(res => {
        this.infoError = true
        this.infoLoading = false
      })
    },
    // 返回上一页
    back () {
      if (window.history.length <= 1) {
        this.$router.push({path: '/'})
        return false
      } else {
        this.$router.go(-1)
      }
    },
    statusTransfer (status) {
      return statusTransfer(status)
    },
    // 获取实例类型详细信息
    getFlavorInfo () {
      if (this.info.flavor.id) {
        detailPrivateCloudFlavor(this.info.flavor.id).then(res => {
          this.flavorInfo = res.data.flavor
        }).catch(res => {
          console.log(res.response)
        })
      }
    },
    // 获取实例类型详细信息
    getImageInfo () {
      if (this.info.image.id) {
        detailPrivateCloudImage(this.info.image.id).then(res => {
          this.imageInfo = res.data
        }).catch(res => {
          console.log(res.response)
        })
      }
    },
    // 获取实例绑定的所有安全组
    getBindSecurityGroup () {
      this.securityGroupsGetting = true
      getPrivateCloudServerSecurityGroups(this.info.id).then(res => {
        this.securityGroups = res.data
        this.securityGroupsGetting = false
      }).catch(res => {
        this.securityGroupsGetting = false
        this.$Notice.error({
          title: '获取已绑定的安全组数据失败！'
        })
      })
    },
    selectMenu (name) {
      this.$router.push({name: name, params: { id: this.$route.params.id }})
    },
    resourceProjectIdTransName (id) {
      return resourceIdTransName('projects', id)
    }
  }
}
</script>

<style lang="less">
  @import './../base.less';
  .resource-tree {
    margin: 20px 0;
    .resource-tree-content {
      position: relative;
      z-index: 1;
      .resource-tree-left-line {
        position: absolute;
        top: 0;
        bottom: 38px;
        width: 1px;
        height: 100%;
        background-color: #999;
        left: 16px;
      }
      .resource-tree-left-line-last {
        height: 50%;
      }
      .resource-tree-content-data {
        padding: 8px 40px;
        .resource-tree-data-body {
          background: #F2F2F2;
          padding: 10px;
          .resource-tree-line-icon {
            width: 25px;
            height: 1px;
            background-color: #999;
            position: absolute;
            left: 16px;
            top: 50%;
          }
        }
      }
    }
  }
</style>
